export default __webpack_public_path__ + "975ce2f0d920a5365c23f7fe48286e4c.svg";